import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import Slide from './Slide1';

import SlideOne from './SlideOne';
import {RegisterBusinessDialog} from 'components/organisms';

const Carousel = ({ slides }) => {
    const swiperRef = useRef(null);

    const [registerDialogOpen, setRegisterDialogOpen] = useState(false);

    useEffect(() => {
        const handleSlideChange = () => {
            if (swiperRef.current && swiperRef.current.swiper) {
                const activeSlide = swiperRef.current.swiper.slides?.[swiperRef.current.swiper.activeIndex];
                if (activeSlide) {
                    activeSlide.classList.add('zoom-in');
                    setTimeout(() => {
                        activeSlide.classList.remove('zoom-in');
                    }, 3000); // Zoom effect lasts 3 second
                }
            }
        };

        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.on('slideChange', handleSlideChange);
        }

        return () => {
            // Ensure swiperRef exists before calling .off()
            if (swiperRef.current && swiperRef.current.swiper) {
                swiperRef.current.swiper.off('slideChange', handleSlideChange);
            }
        };
    }, []);

    return (
        <Swiper
            ref={swiperRef}
            spaceBetween={0}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }} // Auto-slide every 3 seconds
            speed={700}
            loop={true}
            simulateTouch={true}
            modules={[Navigation, Pagination, Autoplay]} // Added Autoplay            
            style={{ backgroundColor: 'white' }}
        >
            <SwiperSlide key={0} >
                <SlideOne title={"Your Brand,\nYour App,\nYour Way!"}
                    subtitle={"Launch your own mobile and web app, fully tailored to your business needs with Mperito in days"}
                    button1Label={"Get Started"}
                    button2Label={"Request Demo"}
                    button1Action={() => setRegisterDialogOpen(true)}
                    button2Action={() => setRegisterDialogOpen(true)}
                />
                <RegisterBusinessDialog
                    open={registerDialogOpen}
                    onClose={() => setRegisterDialogOpen(false)}
                />
            </SwiperSlide>
            {/* {slides.map((slide, index) => (
                <SwiperSlide key={index+1}>
                    <Slide backgroundImage={slide.background} title={slide.title} subtitle={slide.subtitle}/>
                </SwiperSlide>
            ))} */}
        </Swiper>
    );
};

export default Carousel;
